import React from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';
import { selectItemsListState, selectItemStatus } from '../../ducks';
import { Loading } from '../loading';
import { Filter } from '../filter';
import { ItemsList } from './ItemsList';
import { isToppers } from '../../apis/dumpert';
import { adBreakPoint } from '../../lib/helpers';
import { useCurrentBreakPoint } from '../commons';

export const ItemsListRelated = ({ 
  typeOfList, 
  itemId, 
  numOfItems, 
  hideAds, 
  isModal, 
  isWideComments, 
  commentsUnderVideo, 
}) => {

  const { isLoading, isLoaded, error, items } = useSelector(state => selectItemsListState(state, typeOfList));
  const statusItem = useSelector(selectItemStatus);
  const currentBreakPoint = useCurrentBreakPoint();
  const listProps = {
    items: items.slice(0, numOfItems),
    isToppers: isToppers(typeOfList),
    isSidebar: false,
    hideAds: hideAds,
    isModalRelatedItem: isModal ? true : false,
  };
  return (
    <>
      {error && <></>}
      {isLoading && <Loading whatIsLoading="items"/>}
      {isLoaded && (
        <>
          <Filter
            typeOfList={typeOfList}
            relatedItemId={itemId}
            isModal={isModal}
            isItemViewPage={true}
            noItemLoaded={statusItem === 'error'}
          />
          <div className={c(
            'grid',
            { ['one']: ['XS'].includes(adBreakPoint(currentBreakPoint)) || 
              ['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) 
              && commentsUnderVideo && isWideComments },
            { ['two']: ['S'].includes(adBreakPoint(currentBreakPoint)) || 
              ['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) 
              && commentsUnderVideo && !isWideComments },             
            { ['three']: ['M'].includes(adBreakPoint(currentBreakPoint))
            || ['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) && !commentsUnderVideo },
          )}>
            <ItemsList {...listProps} />
          </div>
        </>
      )}
    </>
  );
};
